import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const SafetyConfirmDialog = ({
  open,
  title,
  warning,
  paragraphs = [],
  confirmLabel,
  loading = false,
  onCancel,
  onConfirm,
  maxWidth = 'sm'
}) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth={maxWidth} fullWidth>
    <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
      <WarningAmberIcon color="warning" />
      {title}
    </DialogTitle>
    <DialogContent>
      {warning && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <strong>{warning}</strong>
        </Alert>
      )}
      {paragraphs.map((paragraph, index) => (
        <Typography
          key={index}
          variant="body2"
          sx={{ mt: index === 0 ? 0 : 1.5, color: paragraph.secondary ? 'text.secondary' : 'text.primary' }}
        >
          {paragraph.text || paragraph}
        </Typography>
      ))}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} disabled={loading}>Cancel</Button>
      <Button variant="contained" color="warning" onClick={onConfirm} disabled={loading}>
        {loading && <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />}
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default SafetyConfirmDialog;
